import {types} from 'mobx-state-tree';

const TimezoneModel = types
    .model('TimezoneModel', {
      key: types.string,
    });

export default TimezoneModel;
